import React, { ReactNode, ReactElement, Children } from 'react';

interface Props {
  direction: 'horizontal' | 'vertical';
  spacing: number;
  className?: string;
  children: ReactNode;
}

const StackView = ({
  direction = 'vertical',
  spacing = 0, // Multiplies of 8 which follows tailwind
  className = '',
  children,
  ...props
}: Props): ReactElement => (
  <div
    className={`${direction === 'horizontal' ? 'flex' : ''} ${className}`}
    {...props}
  >
    {Children.map(children, (child, i) => {
      let style;
      if (i < Children.count(children) - 1) {
        if (direction === 'horizontal') {
          style = { marginRight: `${spacing * 8}px` };
        } else {
          style = { marginBottom: `${spacing * 8}px` };
        }
      }

      return <div style={style}>{child}</div>;
    })}
  </div>
);

export default StackView;
